import Highcharts from 'highcharts';
import {
  CHART_AXIS_STYLE,
  TITLE_FONT_FAMILY,
  one,
  pipeLineGas,
  point5,
  ten,
  two,
} from '../../../constants';
import {
  ChartAxisStyle,
  ChartLegendStyle,
  getColorByIndex,
  getSubTitle,
  toolTipFormatter,
} from '../../../utils';
import { SummedValues } from '../CarbonIntensityChart/types';
import { YearProcessedDataItem } from './types';
import { PointsData } from '../../../Types/types';
import { getActualLastYearIndex, updateResRenValue, getOrderInCommodityPage } from '../../CommodityOverview/Utils';
interface HighchartOptionsProps {
  commodityVal: string;
  charTitleType: string;
  chartSubtitleType: string;
  chartSubtitleKPI: string;
  resultYearArray: YearProcessedDataItem[];
  chartType: string;
  processedCombinedArrayWithKey: SummedValues[];
  bizId: string
  evpId: string
  seIpuRegionId: string
  isActualsRefresh: boolean
}
export const highchartOptions = (highchartOptionsData: HighchartOptionsProps) => {
  const column = 'column';
  const actuals = 'actuals';
  const sales = 'sales';
  const left = 'left';
  const bottom = 'bottom';
  const white = 'white';
  const plan = 'Plan';
  const {
    commodityVal,
    charTitleType,
    resultYearArray,
    chartType,
    processedCombinedArrayWithKey,
    bizId,
    evpId,
    seIpuRegionId,
    isActualsRefresh
  } = highchartOptionsData;
  getOrderInCommodityPage(processedCombinedArrayWithKey);
  const title = commodityVal === pipeLineGas ? 'Gas' : commodityVal;
  const categoriesData = [...new Set(resultYearArray.map((x: YearProcessedDataItem) => x.year))];
  const indexOfLastActuals = getActualLastYearIndex(resultYearArray);
  const options: Highcharts.Options = {
    chart: {
      type: column,
      height: 500,
      marginBottom: 100,
    },
    title: {
      text: `${title} ${charTitleType} by Source`,
      align: left,
      x: 16,
      y: 20,
      style: {
        fontSize: '20px',
        fontFamily: TITLE_FONT_FAMILY,
      },
    },
    subtitle: {
      text: getSubTitle(commodityVal, chartType, title),
      align: left,
      x: 16,
      style: {
        fontSize: '14px',
        fontFamily: TITLE_FONT_FAMILY,
        margin: '20px',
        floating: false,
      },
    },
    xAxis: {
      categories: categoriesData,
      plotBands:
        indexOfLastActuals !== -1
          ? [
            {
              color: 'rgba(128, 128, 128, 0.3)',
              from: -point5,
              to: isActualsRefresh ? indexOfLastActuals + one : indexOfLastActuals,
              label: {
                text: 'Actuals',
                style: ChartAxisStyle,
                verticalAlign: bottom,
                y: 40,
              },
            },

            {
              color: white,
              to: indexOfLastActuals,
              label: {
                text: plan,
                style: ChartAxisStyle,
                verticalAlign: bottom,
                y: 40,
              },
            },
          ]
          : [
            {
              color: white,
              from: -point5,
              to: categoriesData.length - 1 + point5,
              label: {
                text: plan,
                style: ChartAxisStyle,
                verticalAlign: bottom,
                y: 40,
              },
            },
          ],
    },
    yAxis: {
      title: {
        useHTML: true,
        style: CHART_AXIS_STYLE,
        text: chartType === sales ? 'Volume (TWh)' : 'Carbon Emission (MTPA)',
      },
    },
    plotOptions: {
      column: {
        stacking: 'normal',
        grouping: false,
        pointWidth: 22,
      },
    },
    legend: {
      x: 16,
      itemStyle: ChartLegendStyle,
      layout: 'horizontal',
      align: left,
      verticalAlign: 'top',
      reversed: true,
    },
    tooltip: {
      shared: true,
      headerFormat: '<span style="font-size:12px"><b>{point.key}</b></span><br>',
      valueDecimals: two,
      formatter() {
        return toolTipFormatter(this as unknown as PointsData, false, true);
      },
    },
    series:
      processedCombinedArrayWithKey && processedCombinedArrayWithKey.length > 0
        ? processedCombinedArrayWithKey.map((dataObj: SummedValues, index: number) => ({
          type: column,
          name: dataObj.name,
          data:
            dataObj?.data instanceof Array
              ? dataObj.data.map((dataPoint: { value: number; type: string, year: string }) => ({
                y: updateResRenValue({ chartType, name: dataObj.name, evp: evpId, seIpuRegionId, reportingEntity: bizId, value: dataPoint.value, year: Number(dataPoint.year), commodityVal }),
                tooltipText: `${dataPoint.type === actuals ? '(Actual)' : ''}`, // Use the custom tooltip text
              }))
              : [],
          actualAndPlanData: dataObj.currentYearPlanAndActualData,
          color: getColorByIndex(index, dataObj.name),
          dataLabels: {
            enabled: false,
            style: {
              fontSize: '12px',
            },
            verticalAlign: bottom,
            y: -ten,
          },
        }))
        : [
          {
            type: column, // Add the series type here
            name: '',
            // data: dataObj.data.map((item) => item.value),
            data: [],
            dataLabels: {
              enabled: false,
              style: {
                fontSize: '12px',
              },
              verticalAlign: bottom,
              y: -10,
            },
          },
        ],
  };
  return options;
};